import React from 'react'
import Colors from '../assets/Colors'
import Fonts from '../assets/Fonts'
import { InputWithSearchIcon } from '../InputWithSearchIcon/InputWithSearchIcon'
import classes from './SearchWithList.module.css'

function SearchWithList({ results, value, setValue, placeholder }) {
    return (
        <div className={classes.searchWithList}>
            <div className={classes.searchBox}>
                <InputWithSearchIcon state={value} setter={setValue} placeholder={placeholder} />
            </div>
            <ul>
                {
                    results?.length == 0 ? <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>Enter State or City name</p>
                        :
                        results?.map(item => <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>{item}</li>)}
            </ul>
        </div>
    )
}

export { SearchWithList }